import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Grid } from '@mui/material';
import { WsDialog, WsTypography, WsTypoVariants, WsButton } from 'wisestep-base';

interface IInviteSuccessModal {
  setOpenInviteSuccessModal: React.Dispatch<React.SetStateAction<boolean>>;
  setOpenInviteUserDialog: React.Dispatch<React.SetStateAction<boolean>>;
}

const InviteUserSuccessModal = ({
  setOpenInviteSuccessModal,
  setOpenInviteUserDialog,
}: IInviteSuccessModal) => (
  <WsDialog openDialog={true}>
    <Grid container p={4}>
      <Grid item xs={12} display="flex" justifyContent="center">
        <CheckCircleIcon fontSize="large" color="success" />
      </Grid>
      <Grid item xs={12} display="flex" gap={2} justifyContent="center" mt={2}>
        <WsTypography variant={WsTypoVariants.SUB_TITLE} bold>
          User has been invited successfully!
        </WsTypography>
      </Grid>
      <Grid item xs={12} display="flex" gap={3} justifyContent="center" mt={3}>
        <WsButton
          onClick={() => {
            setOpenInviteSuccessModal(false);
            setOpenInviteUserDialog(true);
          }}
          variant="outlined"
        >
          Invite More Users!
        </WsButton>
        <WsButton onClick={() => setOpenInviteSuccessModal(false)}>Close</WsButton>
      </Grid>
    </Grid>
  </WsDialog>
);

export default InviteUserSuccessModal;
